import React from "react";
import PropTypes from "prop-types";
import FilterMenu from "BSM/Statistics/components/FilterMenu";
import styles from "./FilterSidebar.module.css";

/**
 * Shared filter sidebar used across the BSM admin (Store catalog, Order
 * Management → Create Order, and Order History). Wraps the shared FilterMenu in
 * a consistent `<aside>` column so every list page gets the same filter look
 * and behavior (per-group clear, reset, Any/All match modes).
 */
export default function FilterSidebar({
  groups = [],
  selectedFilters = {},
  onChange = () => {},
  filterModes = {},
  onModeChange,
  onClearGroup,
  onResetAll,
  className,
}) {
  // A group whose options haven't loaded (or don't exist for the current data)
  // would otherwise render as a bare heading with nothing under it.
  const visibleGroups = React.useMemo(
    () =>
      groups.filter(
        (group) =>
          group &&
          (Array.isArray(group.options) ? group.options.length > 0 : true)
      ),
    [groups]
  );

  return (
    <aside className={`${styles.sidebar}${className ? ` ${className}` : ""}`}>
      <FilterMenu
        filters={visibleGroups}
        selectedFilters={selectedFilters}
        onChange={onChange}
        filterModes={filterModes}
        onModeChange={onModeChange}
        onClearGroup={onClearGroup}
        onResetAll={onResetAll}
      />
    </aside>
  );
}

FilterSidebar.propTypes = {
  groups: PropTypes.array,
  selectedFilters: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)),
  onChange: PropTypes.func,
  filterModes: PropTypes.objectOf(PropTypes.string),
  onModeChange: PropTypes.func,
  onClearGroup: PropTypes.func,
  onResetAll: PropTypes.func,
  className: PropTypes.string,
};
